import {Injectable} from '@angular/core';
import {HttpService} from '../../../services/http.service';

@Injectable()
export class WebNotificationsService {
    api = 'api/@/notifications';
    isLoading: boolean;

    constructor(private httpService: HttpService) {}

    load(username: string, size?: number, page?: number) {
        return this.httpService.get(this.api.replace('@', username) + `?size=${size}&page=${page}`);
    }

    markSeen(username: string, id: number) {
        return this.httpService.post((this.api + `/${id}/seen`).replace('@', username), {});
    }

    loadArchived(username: string) {
        return this.httpService.get((this.api + `/archived`).replace('@', username));
    }

    archive(username: string, id: number) {
        return this.httpService.put((this.api + `/${id}/archive`).replace('@', username), {});
    }

    archiveAllSeen(username: string) {
        return this.httpService.put((this.api + `/archive-unseen`).replace('@', username), {});
    }

    delete(username: string, id: number) {
        return this.httpService.delete((this.api + `/${id}`).replace('@', username), {});
    }
}
